// extracted by mini-css-extract-plugin
export default {"header":"NotificationPopOver-module__header--cF_lO","title":"NotificationPopOver-module__title--HCcfd","markAll":"NotificationPopOver-module__markAll--MUkKf"};